<template>
  <BaseButton :variant="variant" @click="$emit('click')" :disabled="disabled">
    <BaseIcon v-if="isShowIcon" icon-name="remove" :width="iconWidth" :height="iconHeight">
      <IconRemove></IconRemove>
    </BaseIcon>
    <slot></slot>
  </BaseButton>
</template>

<script>
import buttonMixin from '@/mixins/button';
import BaseIcon from '@/components/BaseIcon.vue';
import IconRemove from '@/components/icon/IconRemove.vue';

export default {
  mixins: [buttonMixin],
  components: {
    BaseIcon,
    IconRemove,
  },
  props: {
    variant: { type: String, default: 'outline-secondary' },
  },
};
</script>

<style lang="scss" scoped></style>
